import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../utils/formatNumber';
//
import { BaseOptionChart } from './BaseOptionChart';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 280;
const LEGEND_HEIGHT = 40;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

const CHART_DATA = [70, 54];

export default function Diagnostico() {
  const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    colors: [
      theme.palette.success.dark, theme.palette.success.main
    ],
    labels: ['Cervicalgia','Lombalgia'],
    stroke: { 
      colors: [
              //'#1f78b4'
              theme.palette.background.paper
              ] 
    },
    legend: { floating: true, horizontalAlign: 'center' },
    dataLabels: { 
      enabled: true,
      style: {
        fontSize: '11px',
        fontWeight: 'bold'
      },
      dropShadow: {
        enabled: false 
      } 
    },
    tooltip: {
      fillSeriesColor: true,
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `${seriesName}`
        }
      }
    },
    plotOptions: {
      pie: {
         donut: { 
            labels: {
                show: true,
                name:{}
                }
          } 
        }
    }
  });

  return (
    <Card>
      <CardHeader title="Diagnóstico Clínico" subheader=""/>
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart type="donut" series={CHART_DATA} options={chartOptions} height={250} />
      </ChartWrapperStyle>
    </Card>
  );
}
